import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  clockIcon: {
    width: '17px',
    height: '17px',
  },
}));
